/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReserveShiftsReportList,
    ReserveShiftsReportListFromJSON,
    ReserveShiftsReportListToJSON,
    ReserveShiftsRequest,
    ReserveShiftsRequestFromJSON,
    ReserveShiftsRequestToJSON,
    ReserveTripMap,
    ReserveTripMapFromJSON,
    ReserveTripMapToJSON,
    ReserveTripMapRequest,
    ReserveTripMapRequestFromJSON,
    ReserveTripMapRequestToJSON,
    ReserveTripsReportList,
    ReserveTripsReportListFromJSON,
    ReserveTripsReportListToJSON,
    ReserveTripsRequest,
    ReserveTripsRequestFromJSON,
    ReserveTripsRequestToJSON,
} from '../models';

export interface GetReserveShiftsReportRequest {
    reserveShiftsRequest?: ReserveShiftsRequest;
}

export interface GetReserveTripMapRequest {
    reserveTripMapRequest?: ReserveTripMapRequest;
}

export interface GetReserveTripsReportRequest {
    reserveTripsRequest?: ReserveTripsRequest;
}

/**
 * 
 */
export class ReserveApi extends runtime.BaseAPI {

    /**
     * GO Reserve 乗務レポート
     */
    async getReserveShiftsReportRaw(requestParameters: GetReserveShiftsReportRequest): Promise<runtime.ApiResponse<ReserveShiftsReportList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/reserve_shift_reports`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReserveShiftsRequestToJSON(requestParameters.reserveShiftsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReserveShiftsReportListFromJSON(jsonValue));
    }

    /**
     * GO Reserve 乗務レポート
     */
    async getReserveShiftsReport(requestParameters: GetReserveShiftsReportRequest): Promise<ReserveShiftsReportList> {
        const response = await this.getReserveShiftsReportRaw(requestParameters);
        return await response.value();
    }

    /**
     * GO Reserve １乗車地図
     */
    async getReserveTripMapRaw(requestParameters: GetReserveTripMapRequest): Promise<runtime.ApiResponse<ReserveTripMap>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/reserve_trip_map`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReserveTripMapRequestToJSON(requestParameters.reserveTripMapRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReserveTripMapFromJSON(jsonValue));
    }

    /**
     * GO Reserve １乗車地図
     */
    async getReserveTripMap(requestParameters: GetReserveTripMapRequest): Promise<ReserveTripMap> {
        const response = await this.getReserveTripMapRaw(requestParameters);
        return await response.value();
    }

    /**
     * GO Reserve 営業レポート
     */
    async getReserveTripsReportRaw(requestParameters: GetReserveTripsReportRequest): Promise<runtime.ApiResponse<ReserveTripsReportList>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/reserve_trips_report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReserveTripsRequestToJSON(requestParameters.reserveTripsRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReserveTripsReportListFromJSON(jsonValue));
    }

    /**
     * GO Reserve 営業レポート
     */
    async getReserveTripsReport(requestParameters: GetReserveTripsReportRequest): Promise<ReserveTripsReportList> {
        const response = await this.getReserveTripsReportRaw(requestParameters);
        return await response.value();
    }

}
